import { render, staticRenderFns } from "./QuestionaireParser.vue?vue&type=template&id=24cf2a0a"
import script from "./QuestionaireParser.vue?vue&type=script&lang=js"
export * from "./QuestionaireParser.vue?vue&type=script&lang=js"
import style0 from "./QuestionaireParser.vue?vue&type=style&index=0&id=24cf2a0a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports